import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <div className="footer my-2">
        <a href="https://api.whatsapp.com/send?phone=+5215534080960&text=Hola,%20v%C3%AD%20tu%20contacto%20en%20una%20sitio%20web">Contactar al desarrollador</a>
    </div>
  )
}

export default Footer;